import * as React from 'react';
import { useContext } from 'react';

import type { SaveProductManager } from 'bundles/unified-description-page-common/utils/SaveProductManager';

type CourseraPlusSavedProductContextType = {
  isSavedLoading?: boolean;
  isSaved?: boolean;
  saveProductManager: SaveProductManager;
};

const CourseraPlusSavedProductContext = React.createContext<CourseraPlusSavedProductContextType | undefined>(undefined);

export const useSavedProduct = () => {
  const savedProductContext = useContext(CourseraPlusSavedProductContext);

  return savedProductContext;
};

export default CourseraPlusSavedProductContext;
